import clsx from "clsx";

/** Ошибка рядом с действием — человеческим текстом сервиса (вариант проекта; в барреле проекта — `ErrorLine`). */
export function ErrorAlert({ text, className }: { text: string | null | undefined; className?: string | undefined }) {
  if (!text) return null;
  return (
    <div
      role="alert"
      className={clsx(
        "rounded-[var(--radius-ui)] border border-err/40 bg-err-bg px-2.5 py-1.5 text-[12px] text-err",
        className,
      )}
    >
      {text}
    </div>
  );
}
